import React from 'react';
import { useWindowSize, useWindowScroll } from 'react-use';

import useDeviceScreen from 'lib/hooks/useDeviceScreen';
import ChevronIcon from 'components/Shared/ChevronIcon';
import { colors } from 'components/styles/variables';

export default function BackToTopButton(): JSX.Element | null {
  const { isMobile, isTablet } = useDeviceScreen();
  const { height } = useWindowSize();
  const { y } = useWindowScroll();

  if (y < height || isMobile || isTablet) {
    return null;
  }

  function handleClick(): void {
    window.scrollTo({ top: 0 });
  }

  return (
    <button className="back-to-top-button" onClick={handleClick} data-testid="back-to-top-button">
      <ChevronIcon isPointedUp color={colors.BLACK} />
      <span className="back-to-top-button-label">TOP</span>
      <style jsx>{`
        .back-to-top-button {
          position: fixed;
          z-index: 1;
          bottom: 60px;
          right: 24px;
          background: ${colors.WHITE};
          color: inherit;
          font: inherit;
          cursor: pointer;
          outline: inherit;

          height: 60px;
          width: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 60px;
          border: solid 1px ${colors.G1};
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        }

        .back-to-top-button-label {
          display: none;
          font-size: 14px;
          line-height: 20px;
          font-weight: bold;
          position: relative;
          top: -3px;
          color: ${colors.BLACK};
        }

        .back-to-top-button:hover > .back-to-top-button-label {
          display: initial;
        }
      `}</style>
    </button>
  );
}
